module.exports = __webpack_public_path__ + "static/media/26UNRWA16.1f1cba40.jpg";